import { IsObject, noop } from '../../../helpers';
export function InitObservableHook(observable, privates, createContext, create) {
    privates.onObserveHook = noop;
    privates.onUnobserveHook = noop;
    if (typeof create === 'function') {
        const hook = create.call(observable, createContext(observable));
        if (hook !== void 0) {
            if (IsObject(hook)) {
                if (typeof hook.onObserved === 'function') {
                    privates.onObserveHook = hook.onObserved.bind(observable);
                }
                if (typeof hook.onUnobserved === 'function') {
                    privates.onUnobserveHook = hook.onUnobserved.bind(observable);
                }
            }
            else {
                throw new TypeError(`Expected object or void as return of ${observable.constructor.name}'s create function.`);
            }
        }
        return hook;
    }
    else if (create !== void 0) {
        throw new TypeError(`Expected function or void as ${observable.constructor.name}'s create function.`);
    }
}
//# sourceMappingURL=init.js.map